<template>
    <div class="conatiner">
        <!-- <div style="text-align: center;margin: 10px 0;">请选择你要进行的操作</div> -->
        <div class="card-top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
        <div class="form-div">
            <el-form style="text-align: center;">
                <el-form-item>
                    <el-radio-group v-model="type" v-removeHidden>
                        <el-radio :label="1" border>文化生忘记密码</el-radio>
                        <el-radio :label="2" border>艺术生忘记密码</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clickToRegister">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            type:1
        };
    },
    methods:{
        clickToRegister(){
            const type=this.type;
            if(type===1){
                this.$router.push("/main/findPwd");
            }else{
                this.$router.push("/main/yshForgetPwd");
            }
        }
    }
}
</script>
<style lang="less" scoped>
.conatiner{
    .form-div{
        width: 600px;
        margin: 20px auto;
    }
    .card-top{
        width: 1100px;
        margin: 20px auto;
    }
}
</style>
